import Vue from 'vue';

if (document.querySelector('#suggest-a-spot-vue')) {

    Vue.component('search-spot', require('@/components/SuggestSpot/Search').default);

    window.suggestSpot = new Vue({
        name: 'Suggest a Spot',
        el: '#suggest-a-spot-vue',
        methods: {
            google() {
                eventBus.$emit('google-api-ready')
            }
        }
    });
}
